import React from 'react';
import PreviewQuestionShell from './PreviewQuestionShell';

const SingleChoiceQuestionBlock = ({ question, register, errors }) => (
    <PreviewQuestionShell question={question} error={errors[question.internalId]?.message}>
        <div className="ecx-survey-preview-q__options">
            {question.options?.map((opt) => (
                <label key={opt.id} className="ecx-survey-preview-q__option">
                    <input
                        className="form-check-input"
                        type="radio"
                        value={opt.value}
                        {...register(question.internalId, {
                            required: question.required ? `${question.title} is required` : false,
                        })}
                    />
                    <span>{opt.text}</span>
                </label>
            ))}
        </div>
    </PreviewQuestionShell>
);

export default SingleChoiceQuestionBlock;
